const en = {
  // Navigation
  BACK: "Back",
  NEXT: "Next",

  // Actions
  SPEAK: "Speak",
  LISTEN: "Listen",
  RETRY: "Retry",
  SUBMIT: "Submit",
  START: "Start",
  SKIP: "Skip",

  // Status
  LOADING: "Loading...",
  LOADING_GAME: "Loading game...",

  // Feedback
  HURRAY: "Hurray!!!",
  ALMOST_THERE: "Almost There!!!",
  GREAT: "Awesome! You did great!",
  DEMO_COMPLETE: "Demo Complete!",

  // Errors
  GAME_ERROR: "Error loading game",
  NO_OPTIONS: "No options available",
  MIC_PERMISSION:
    "We need permission to hear you! Please allow microphone access.",
  CANT_HEAR: "We can't hear you!",

  // Microphone / Audio
  MIC_TEST: "Let's test your microphone!",
  LISTEN_AND_REPEAT: "Hi! Listen to the audio and repeat it!",
  ALL_TESTS_PASSED: "All tests passed! You're ready to start learning!",
  CLICK_LISTEN: "Click to listen",

  // Phone conversation activity
  PHONE_RINGS: "Phone rings...",
  CONVO_DONE: "Conversation Complete!",

  // Practice.jsx — activity headers
  PRACTICE_GUESS_IMAGE: "Guess the below image",
  PRACTICE_SPEAK_WORD: "Speak the below word",
  PRACTICE_SPEAK_BELOW: "Speak the below",
  PRACTICE_READ_QUESTION_RECORD_RESPONSE:
    "Read the question and record your response",
  PRACTICE_READ_QUESTION_SELECT_ANSWER:
    "Read the question and select correct answer",
  PRACTICE_LOOK_PICTURE_SPEAK_ANSWER:
    "Look at the picture and speak the correct answer from below",
  PRACTICE_FORM_SENTENCE_SPEAK: "Form a sentence using the words and speak",
  PRACTICE_FILL_IN_THE_BLANK: "Fill in the blank",
  PRACTICE_LETTER_RECOGNITION: "Letter Recognition",
  PRACTICE_MEMORY_CHALLENGE: "Memory Challenge",
  PRACTICE_F3_APPLY_LETTER_SPEED: "Apply {step} - Letter Speed",
  PRACTICE_F3_PRACTICE_LETTER_SPEED: "Practice {step} - Letter Speed",
  PRACTICE_LETTER_LAUNCHER_TITLE: "Letter Launcher",
  PRACTICE_LETTER_LAUNCHER_NOT_IMPLEMENTED:
    "Letter Launcher component not yet implemented.",
  PRACTICE_UNABLE_LOAD_CONTENT_RETRY: "Unable to load content. Please retry.",
  PRACTICE_UNABLE_LOAD_F2_STEP_RETRY:
    "Unable to load F2 flow step. Please retry.",
  PRACTICE_UNABLE_LOAD_F3_STEP_RETRY:
    "Unable to load F3 flow step. Please retry.",
  PRACTICE_UNABLE_LOAD_F1_STEP_RETRY:
    "Unable to load F1 flow step. Please retry.",
  PRACTICE_F3_LETTER_LAUNCHER_STUB_TITLE: "F3 Flow - Letter Launcher",

  // Assesment.jsx — discovery screen, header, dialogs
  ASSESSMENT_TEST_LANGUAGE_SKILLS: "Let's test your language skills",
  ASSESSMENT_GOOD_LANGUAGE_SKILLS: "You have good language skills",
  ASSESSMENT_TAKE_COMPLETE_LEVEL:
    "Take the assessment to complete Level {level}.",
  ASSESSMENT_TAKE_DISCOVER_LEVEL: "Take the assessment to discover your level",
  ASSESSMENT_START_F1: "Start F1",
  ASSESSMENT_START_F2: "Start F2",
  ASSESSMENT_START_F3: "Start F3",
  ASSESSMENT_LEARN_LETTERS: "Learn Letters",
  ASSESSMENT_START_LEVEL: "Start Level {level}",
  ASSESSMENT_WORDS_LEARNT: "Words Learnt",
  ASSESSMENT_WORDS_PER_MINUTE: "Words per minute",
  ASSESSMENT_SELECT_LANGUAGE: "Select Language",
  ASSESSMENT_LANGUAGE_SHORT: "Language",
  ASSESSMENT_AUDIO_TEST: "Audio Test",
  ASSESSMENT_ALPHABET_CHART: "Alphabet Chart",
  ASSESSMENT_LOGOUT: "Logout",
  ASSESSMENT_GO_HOME_CHANGE_LANGUAGE: "go to homescreen to change language",
  ASSESSMENT_DIALOG_OOPS: "Oops...",
  ASSESSMENT_DIALOG_CONTINUE: "Continue",
  ASSESSMENT_LANG_CONFIRM: "Confirm",
};

export default en;
